"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileProgress = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const enums_1 = require("@bemlo/enums");
const utils_1 = require("@bemlo/utils");
const constants_1 = require("../../../constants");
const elements_1 = require("../../../elements");
const Flex_1 = require("../../../elements/Flex");
const ResearchingConceptIllustration_1 = require("../../../svgs/ResearchingConceptIllustration");
const translate_1 = require("../../../translate");
const useCandidateView_1 = require("../hooks/useCandidateView");
const scopes_1 = require("../scopes");
const EMPTY_PROFILE_MAX_PERCENTAGE = 20;
const ConfigVectorImage = (0, styled_1.default)(ResearchingConceptIllustration_1.ResearchingConceptIllustration) `
  pointer-events: none;
`;
const ConfigVectorImageWrapper = styled_1.default.div `
  display: none;
  width: 40%;

  @container (min-width: 550px) {
    display: block;
  }
`;
const ProfileProgress = ({ onAddAuthorizationClick, onAddFileUploadClick, onAddReferenceClick, profileCompletionPercentage, }) => {
    const { actor, data, isEditing } = (0, useCandidateView_1.useCandidateView)();
    const t = (0, translate_1.useTranslations)();
    if (isEditing()) {
        return null;
    }
    const scope = scopes_1.scopes.profileProgress();
    if (!actor.can('read', scope)) {
        return null;
    }
    const { fileUploads, hpr } = data;
    const canUpdateReferences = actor.can('update', scopes_1.scopes.references());
    const canUpdateHpr = actor.can('update', scopes_1.scopes.information.hpr());
    const ctaRows = [
        {
            icon: 'AcademicCapIcon',
            isCompleted: canUpdateHpr
                ? !!hpr
                : !!fileUploads?.some(({ uploadType }) => uploadType === enums_1.FileUploadType.LICENSE),
            label: canUpdateHpr
                ? t.candidate_view.profile_progress.add_authorization()
                : t.candidate_view.profile_progress.upload_license(),
            onClick: canUpdateHpr
                ? onAddAuthorizationClick
                : () => onAddFileUploadClick(enums_1.FileUploadType.LICENSE),
        },
        {
            icon: 'PencilIcon',
            isCompleted: !!fileUploads?.some(({ uploadType }) => uploadType === enums_1.FileUploadType.CV),
            label: t.candidate_view.profile_progress.upload_cv(),
            onClick: () => onAddFileUploadClick(enums_1.FileUploadType.CV),
        },
        canUpdateReferences && {
            icon: 'UsersIcon',
            isCompleted: data.references && data.references.length >= 1,
            label: t.candidate_view.profile_progress.invite_a_reference(),
            onClick: onAddReferenceClick,
        },
    ]
        .filter(utils_1.isTruthy)
        .filter((ctaRow) => !ctaRow.isCompleted);
    if (!ctaRows.length) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(Flex_1.Flex, { justify: "end", styles: {
            backgroundColor: constants_1.Color.LIGHTEST_BLUE,
            borderBottomLeftRadius: constants_1.theme.border.radius.normal - 1,
            borderBottomRightRadius: constants_1.theme.border.radius.normal - 1,
            borderLeftColor: constants_1.Color.BLUE,
            borderLeftStyle: 'solid',
            borderLeftWidth: constants_1.theme.border.width.thick,
            borderTopColor: constants_1.Color.LIGHTER_BLUE,
            borderTopStyle: 'solid',
            borderTopWidth: constants_1.theme.border.width.thin,
            p: 3.5,
            position: 'relative',
            pt: 4.5,
            textAlign: 'right',
            userSelect: 'none',
            containerType: 'inline-size',
        }, children: [(0, jsx_runtime_1.jsxs)(Flex_1.Flex, { col: true, gap: 3.5, children: [(0, jsx_runtime_1.jsxs)(Flex_1.Flex, { col: true, gap: 1, justify: "end", children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, size: 3, children: profileCompletionPercentage <= EMPTY_PROFILE_MAX_PERCENTAGE
                                    ? `${t.candidate_view.profile_progress.your_profile_looks_empty()}...`
                                    : t.candidate_view.profile_progress.your_profile_is_n_percent_done(profileCompletionPercentage) }), (0, jsx_runtime_1.jsx)(elements_1.Text, { color: constants_1.Color.MEDIUM_BLUE, size: 6, children: t.candidate_view.profile_progress.maximize_your_chances() })] }), (0, jsx_runtime_1.jsx)(Flex_1.Flex, { col: true, gap: 2, items: "end", children: ctaRows.map((ctaRow) => ((0, jsx_runtime_1.jsxs)(Flex_1.Flex, { gap: 2.5, items: "center", onClick: ctaRow.onClick, styles: { cursor: 'pointer' }, children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, color: constants_1.Color.BLUE, size: 5, children: ctaRow.label }), (0, jsx_runtime_1.jsx)(elements_1.Icon, { backgroundColor: constants_1.Color.LIGHTER_BLUE, color: constants_1.Color.BLUE, name: ctaRow.icon, round: true, size: "lg" })] }, ctaRow.label))) })] }), (0, jsx_runtime_1.jsx)(ConfigVectorImageWrapper, { children: (0, jsx_runtime_1.jsx)(ConfigVectorImage, {}) })] }));
};
exports.ProfileProgress = ProfileProgress;
